import { render } from "./proposaldetailscheckdiy.vue?vue&type=template&id=617e233a&scoped=true"
import script from "./proposaldetailscheckdiy.vue?vue&type=script&lang=js"
export * from "./proposaldetailscheckdiy.vue?vue&type=script&lang=js"

import "./proposaldetailscheckdiy.vue?vue&type=style&index=0&id=617e233a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617e233a"]])

export default __exports__